/**
 * Check varible or object to 'is undefined', 'is empty' or 'is null'
 * @param obj
 */
function isUndefinedOrNullOrEmpty(obj) {
  return angular.isUndefined(obj) || obj === null ||  obj.length === 0 || typeof obj === 'object' && Object.keys(obj).length === 0;
}

export {
  isUndefinedOrNullOrEmpty
};



// WEBPACK FOOTER //
// ./client/app/common/utils/isUndefinedOrNullOrEmpty.js